import React from "react"

import {
    AuthHeader as AuthHeaderComponent,
    SimpleHeader as SimpleHeaderComponent,
    SimpleFooter as SimpleFooterComponent,
    AuthFooter as FooterComponent,
    AuthMenu as MenuComponent,
    LeftMenu as LeftMenuComponent,
    Messages as MessagesComponent,
    Spinner as SpinnerComponent
} from "@sogei/react-web-components-catalog"

import UIContext from "@/context/ui-context"
import { ServiceResponse } from "@/services/ajax-service"
import { Header, SmallAuthMenu } from "@sogei/react-web-components-catalog"
import { Link, MemoryRouter } from "react-router-dom"
import Logo from "./isa_statistiche_logo.png"
import FooterLogo from "./AE_mono_152.png"
// eslint-disable-next-line @typescript-eslint/no-var-requires
const headerLogo = Logo
// eslint-disable-next-line @typescript-eslint/no-var-requires
const footerLogo = FooterLogo

const organization = {
    name: "Agenzia delle entrate",
    url: "https://www.agenziaentrate.gov.it/"
}

const buttonList: any[] = [
    // {
    //     url: "http://alm-admin.sogei.it",
    //     icon: "fas fa-info",
    //     title: "Info e Assistenza"
    // }
]

const title = ""
const subtitle = ""

interface UserInfoState {
    label: string
    username: string
    extraContent: JSX.Element
    entryLabel: string
    entry: string
}

interface MenuItem {
    label: string
    icon: string
    path: string
    exact: string
    subItem?: Array<MenuItem>
}

interface AuthMenuState {
    menuItems: Array<MenuItem>
    fetched: boolean
}

interface LeftMenuState {
    menuItems: Array<MenuItem>
    fetched: boolean
    label: string
}

const AuthHeader = (): JSX.Element => {
    const initialState: UserInfoState = {
        label: "",
        username: "",
        extraContent: <></>,
        entryLabel: "",
        entry: ""
    }

    const data = React.useContext(UIContext)
    //const service = data.service

    const props = {
        title: title,
        logo: headerLogo,
        organization: organization,
        buttonList: buttonList
    }

    const socialInfo = [
        { label: "Facebook", url: "#", icon: "fab fa-facebook-f" },
        { label: "Twitter", url: "#", icon: "fab fa-twitter" },
        { label: "YouTube", url: "#", icon: "fab fa-youtube" }
    ]
    //const organization = { url: "", name: "Nome amministrazione afferente" }

    return (
        <Header
            {...props}
            menuId="menu-id"
            organization={organization}
            socialInfo={socialInfo}
        ></Header>
    )
}

const AuthMenu = (): JSX.Element => {
    const initialState: AuthMenuState = {
        menuItems: [],
        fetched: false
    }

    const [menu, setMenu] = React.useState(initialState)

    const data = React.useContext(UIContext)
    const service = data.service


    const menuItems = [
        {
            items: [
                {
                    label: "Home",
                    icon: "fas fa-home",
                    path: '/StatisticheIsaWeb/',
                    remote: true,
                    target: "_self"
                }
            ]
        }
    ]

    const props = {
        menuItems: menuItems,
        externalClass: {
            li: "text-md-center",
            a: "px-md-3"
        }
    }

    return (
        <MemoryRouter>
        {" "}
        <SmallAuthMenu
            {...props}
            //menuItems={menuItems}
            fetchMenuItems={() => {}}
            idMenu=""
        >
            {" "}
        </SmallAuthMenu>
    </MemoryRouter>
    )
}

const LeftMenu = (): JSX.Element => {
    const initialState: LeftMenuState = {
        menuItems: [],
        fetched: false,
        label: ""
    }

    const [menu, setMenu] = React.useState(initialState)

    const data = React.useContext(UIContext)
    const service = data.service
    const history = data.history

    const fetchLeftMenuItems = (): void => {
        if (!menu.fetched) {
            service
                .doAjax("GET", "/left-menu-items")
                .then((response: ServiceResponse) => {
                    setMenu({
                        menuItems: response.data.items,
                        label: response.data.sectionTitle.label,
                        fetched: true
                    })
                })
        }
    }

    const props = {
        context: process.env.CONTEXT_PATH,
        title: title,
        leftMenuItems: menu.menuItems,
        label: menu.label
    }
    return (
        <LeftMenuComponent
            {...props}
            location={history.location}
            fetchLeftMenuItems={fetchLeftMenuItems}
        />
    )
}

const AuthFooter = (): JSX.Element => (
    <FooterComponent
        logo={footerLogo}
        title={"Statistiche ISA"}
        subtitle={""}
    />
)
const SimpleHeader = (): JSX.Element => (
    <SimpleHeaderComponent
        logo={headerLogo}
        title={title}
        subtitle={subtitle}
    />
)
const SimpleFooter = (): JSX.Element => <SimpleFooterComponent title={title} />

interface MessagesProps {
    extraClass: Array<string>
}

const Messages = (props: MessagesProps): JSX.Element => {
    const data = React.useContext(UIContext)
    return <MessagesComponent {...data} {...props} />
}

const Spinner = (): JSX.Element => {
    const props = React.useContext(UIContext)
    return <SpinnerComponent {...props} />
}

export {
    AuthHeader,
    SimpleHeader,
    SimpleFooter,
    AuthFooter,
    AuthMenu,
    LeftMenu,
    Spinner,
    Messages
}
